module.exports = __webpack_public_path__ + "img/EmailOutlined.ac7486a8.svg";